// components
import { OverviewContainer } from 'components/checkout/containers/overview/overview-container';

type Step1Props = {
  locale: string;
  ciamId: string;
  sessionId: string;
}

export function Step1({ locale, ciamId, sessionId }: Readonly<Step1Props>) {
  const isLoggedIn = Boolean(ciamId && ciamId !== '');

  return (
    <OverviewContainer
      locale={locale}
      ciamId={ciamId}
      isLogged={isLoggedIn}
      sessionId={sessionId}
    />
  );
}
